export default "__VITE_ASSET__BYYfWH8L__"